import { Validator } from 'vee-validate';

/**
 * A no op validator whose only job is to add the field to the vee-validator's fields but does no validation
 * This will help check the component for their flags, eg: changed, dirty, pristine, etc.
 */
Validator.extend('no_op', () => true);
